import { prop } from "ramda";
import { createSelector } from "reselect";

const appSelector = (state: any) => state.app;

export const selectUserInfo: any = createSelector(appSelector, prop("user"));

export const selectUserRoles: any = createSelector(
  selectUserInfo,
  prop("roles")
);

export const selectUserRolesListOriginal: any = createSelector(
  selectUserRoles,
  prop("basicRoles")
);

export const selectUserRolesList: any = createSelector(
  selectUserRolesListOriginal,
  (roles) => {
    let temp = [] as any[];
    for (var i = 0; i < roles.length; i++) {
      let obj = {
        id: i,
        roleName: roles[i].roleName,
      };
      temp.push(obj);
    }
    return temp;
  }
);

export const selectAccessFromInternet: any = createSelector(
  appSelector,
  prop("accessFromInternet")
);

export const selectFloatingSpinner: any = createSelector(
  appSelector,
  prop("floatSpinner")
);

export const selectIsAuthenticated: any = createSelector(
  appSelector,
  (data) => {
    const tokenSession = sessionStorage.getItem("token");
    if (
      (data.token && data.token !== "") ||
      (tokenSession && tokenSession !== null)
    ) {
      return true;
    }
    return false;
  }
);

export const selectLanguage: any = createSelector(
  appSelector,
  prop("language")
);

export const selectLoginExpired: any = createSelector(
  appSelector,
  prop("loginExpired")
);

export const makeSelectLang = () =>
  createSelector(appSelector, prop("language"));

export const selectModalTrigger: any = createSelector(
  appSelector,
  prop("modalTrigger")
);

export const selectErrorCode: any = createSelector(
  appSelector,
  prop("errorCode")
);

export const selectErrorText: any = createSelector(
  appSelector,
  prop("errorText")
);
